import { useMemo } from 'react'
import type { Permission } from './permissions'
import { useAuth } from './useAuth'

export interface PermissionsApi {
  /** Bitta huquq bormi (04-ROLES.md §8) */
  can: (permission: Permission) => boolean
  /** Ro'yxatdagilardan KAMIDA BITTASI bormi — bo'lim ko'rsatish uchun */
  canAny: (...permissions: readonly Permission[]) => boolean
  /** Ro'yxatdagilarning HAMMASI bormi — ko'p qadamli amal uchun */
  canAll: (...permissions: readonly Permission[]) => boolean
  permissions: ReadonlySet<Permission>
}

const EMPTY: ReadonlySet<Permission> = new Set<Permission>()

/**
 * Huquq tekshiruvi hook'i.
 *
 * ⚠️ Bu QULAYLIK, xavfsizlik EMAS. Backend har so'rovda qayta tekshiradi
 * (04-ROLES.md §5, uch qatlam). Bu yerda yashirishning yagona maqsadi —
 * foydalanuvchiga bosib bo'lmaydigan tugma ko'rsatmaslik.
 */
export function usePermissions(): PermissionsApi {
  const { user, can } = useAuth()
  const permissions = user?.permissions ?? EMPTY

  return useMemo<PermissionsApi>(
    () => ({
      can,
      canAny: (...list) => list.some((p) => permissions.has(p)),
      canAll: (...list) => list.every((p) => permissions.has(p)),
      permissions,
    }),
    [can, permissions],
  )
}
